module.exports = __webpack_public_path__ + "static/media/ic_commercial_active.5325296c.svg";